<template>
  <div class="check_data">
    <div class="check_one">
      <div class="padding_left">
        <span class="font_size">选择用户：</span>
        <el-select v-model="changeUser" placeholder="请选择">
          <el-option
            v-for="(item,index) in listUsers"
            :key="index"
            :label="item.username"
            :value="item.username">
          </el-option>
        </el-select>
      </div>
      <div class="padding_left">
        <span class="font_size">选择生产单元：</span>
        <el-select v-model="changeCell" placeholder="请选择">
          <el-option
            v-for="(item,index) in listCells"
            :key="index"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="query_chart">
      <el-tabs v-model="activeName">
        <el-tab-pane
          v-for="(cell_param,index) in cell_params"
          :key = "index"
          :label="cell_param.typeCHN"
          :name="cell_param.snpid">
          <div class="query_history_time query_z-index" style="z-index: 88;width: 35%; margin-left: 65%">
            时间选择：
            <el-date-picker
              v-model="his_time"
              type="datetimerange"
              :picker-options="pickerOptions"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['12:00:00', '08:00:00']">
            </el-date-picker>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="hisQurey" ref="hisQurey" :style="{width: curWidth, height:'470px'}"></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeName: '',
      all_data: [],
      cell_params: [],
      cell_params_all: [],
      params_type: '',
      his_data_name: [],
      his_data_x: {},
      listUsers: [],
      listCells: [],
      changeUser: '',
      changeCell: '',
      his_time: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
            this.his_time = [start, end]
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近半年',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      token: window.sessionStorage.getItem('token'),
      flag: '0',
      curWidth: ''
    }
  },
  methods: {
    // 获取 所有用户信息
    getAllusers () {
      this.listUsers = []
      this.axios.get(this.$store.state.loginIp + 'admin/lists',
        {
          params: {'pageSize': 40, 'role': '2'},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listUsers = res.data.data.list
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取 用户的生产单元信息
    getAllCells () {
      this.listCells = []
      this.axios.get(this.$store.state.ip + 'celldef/listUserCells',
        {
          params: {'username': this.changeUser, 'pageSize': 30},
          headers: {'Authorization': 'Bearer ' + window.sessionStorage.getItem('token')}
        }).then(res => {
        // console.log(res.data.data)
        this.listCells = res.data.data.list
      }).catch(err => {
        console.log(err)
      })
    },
    cellParams () {
      this.cell_params = []
      this.axios.get(this.$store.state.ip + 'sensordef/cellParams',
        {
          params: {'cell_id': this.changeCell},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.cell_params_all = res.data.data
        let j
        for (let i = 0; i < res.data.data.length; i++) {
          for (j = i + 1; j < res.data.data.length; j++) {
            if (res.data.data[i].type === res.data.data[j].type) {
              break
            }
          }
          if (j === res.data.data.length) {
            res.data.data[i].snpid = res.data.data[i].snpid.toString()
            this.cell_params.push(res.data.data[i])
          }
        }
        if (this.cell_params.length !== 0) {
          this.activeName = this.cell_params[0].snpid
          this.flag = '1'
        }
      }).catch(err => {
        console.log(err)
      })
    },
    drawLine () {
      console.log('1')
      this.his_data_x = []
      this.axios.get(this.$store.state.ip + 'opt/hisAggrQuery',
        {
          params: {'cell_ids': this.changeCell, 'snp_types': this.params_type, 'start_time': this.his_time[0], 'end_time': this.his_time[1]},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        for (let i = 0; i < res.data.data.length; i++) {
          this.all_data = res.data.data[i].sntvs
        }
        var series = []
        const color1 = ['#91c7ae', '#d48265', '#61a0a8', '#2f4554', '#749f83', '#c23531']
        let num = 0
        let name = 0
        this.his_data_x = this.all_data[0].times
        for (let i = 0; i < this.all_data.length - 1; i++) {
          for (let j = i + 1; j < this.all_data.length; j++) {
            if (this.all_data[i].times.length < this.all_data[j].times.length) {
              this.his_data_x = this.all_data[j].times
            }
          }
        }
        for (let t = 0; t < this.his_data_x.length; t++) {
          this.his_data_x[t] = this.resetTime(this.his_data_x[t])
        }
        for (let j = 0; j < this.all_data.length; j++) {
          for (let k = 0; k < this.cell_params_all.length; k++) {
            if (this.all_data[j].snpid.toString() === this.cell_params_all[k].snpid.toString()) {
              this.his_data_name[name++] = this.cell_params_all[k].name
              break
            }
          }
          if (num === 6) {
            num = 0
          }
          var test = []
          for (let k = 0; k < this.all_data[j].times.length; k++) {
            test.push({
              'value': this.all_data[j].values[k],
              'time': this.resetTime(this.all_data[j].times[k])
            })
          }
          series.push({
            name: this.his_data_name[name - 1],
            type: 'line',
            itemStyle: {
              normal: { // 背景色渐变
                // color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                //   offset: 0, color: color1[j]
                // }, {
                //   offset: 0.5, color: 'rgba(174, 212, 194, 0.5)'
                // }, {
                //   offset: 0.85, color: '#fff'
                // }]),
                lineStyle: { // 折线样式
                  width: 2.5,
                  type: 'solid',
                  color: color1[num] // 拆线颜色
                }
              },
              emphasis: {
                color: color1[num],
                lineStyle: {
                  type: 'dotted',
                  color: color1[num++]
                }
              }
            },
            symbolSize: 5,
            data: test
          })
        }
        let mycharts = this.$echarts.init(this.$refs.hisQurey)
        mycharts.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          color: ['#91c7ae', '#d48265', '#61a0a8', '#2f4554', '#749f83', '#c23531'],
          legend: {
            left: 20,
            data: this.his_data_name
          },
          dataZoom: [
            {
              show: true,
              realtime: true,
              start: 0
              // end: 25 / this.his_data_x[0].length * 100
            },
            {
              type: 'inside',
              realtime: true,
              start: 0,
              end: 100
            }
          ],
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.his_data_x
            }
          ],
          yAxis: [
            {
              type: 'value',
              axisTick: {
                show: false
              }
            }
          ],
          series: series
        }, true)
      }).catch(err => {
        console.log(err)
      })
    },
    // 时间戳转换为标准时间
    resetTime (time) {
      let test = new Date(time * 1000)
      let year = test.getFullYear() // 取得4位数的年份
      let month = ('0' + (test.getMonth() + 1)).slice(-2) // 取得日期中的月份，其中0表示1月，11表示12月
      let date = ('0' + test.getDate()).slice(-2) // 返回日期月份中的天数（1到31）
      let hour = ('0' + test.getHours()).slice(-2) // 返回日期中的小时数（0到23）
      let minute = ('0' + test.getMinutes()).slice(-2) // 返回日期中的分钟数（0到59）
      let second = ('0' + test.getSeconds()).slice(-2) // 返回日期中的秒数（0到59）
      return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
    },
    // 标准时间 转换为 yyyy:mm:dd hh:mm:ss
    changeTime (time) {
      const resDate = time.getFullYear() + '-' + this.p((time.getMonth() + 1)) + '-' + this.p(time.getDate())
      const resTime = this.p(time.getHours()) + ':' + this.p(time.getMinutes()) + ':' + this.p(time.getSeconds())
      return resDate + ' ' + resTime
    },
    p (s) {
      return s < 10 ? '0' + s : s
    }
  },
  created () {
    this.getAllusers()
    this.curWidth = document.body.clientWidth - 260 + 'px'
  },
  watch: {
    'changeUser': function () {
      this.getAllCells()
    },
    'changeCell': function () {
      this.cellParams()
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24)
      this.his_time = [this.changeTime(start), this.changeTime(end)]
    },
    'activeName': function () {
      for (let i = 0; i < this.cell_params.length; i++) {
        if (this.activeName === this.cell_params[i].snpid) {
          this.params_type = this.cell_params[i].type
          break
        }
      }
      this.drawLine()
    },
    'his_time': function () {
      if (this.flag === '1') {
        this.drawLine()
      }
    }
  }
}
</script>

<style scoped>
  .check_one {
    display: flex;
    justify-content: left;
    align-items: center;
    height: 60px;
    background-color: white;
    border-radius: 4px;
  }
  .padding_left{
    padding-left: 30px;
  }
  .font_size {
    font-size: 14px;
    font-weight: 400;
  }
  .query_time {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: -20px;
  }
  .hisQurey{
    margin: 0 auto;
    margin-top: -30px;
    padding-bottom: 15px;
  }
  .el-select {
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    width: 175px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/analysisData.vue